import bulkViewOperations from './bulk-view-operations';
import setElementAttribute from './set-element-attribute';
import setInlineElementStyle from './set-inline-element-style';
import copyElement from './copy-element';
import cutElement from './cut-element';
import pasteElement from './paste-element';
import synchronizeElement from './synchronize-element';
import removeElementAttribute from './remove-element-attribute';
import replaceElement from './replace-element';
import setHoveredElement from './set-hovered-element';
import triggerSelectionUpdate from './trigger-selection-update';
import deleteElement from './delete-element';
import setSelectedElement from './set-selected-element';
import insertBlock from './insert-block';
import setResponsiveAttribute from './set-responsive-attribute';
import setResponsiveClass from './set-responsive-class';
import removeResponsiveClass from './remove-responsive-class';

export default {
  bulkViewOperations,
  copyElement,
  cutElement,
  deleteElement,
  pasteElement,
  setElementAttribute,
  setInlineElementStyle,
  synchronizeElement,
  removeElementAttribute,
  replaceElement,
  setHoveredElement,
  triggerSelectionUpdate,
  setSelectedElement,
  insertBlock,
  setResponsiveAttribute,
  setResponsiveClass,
  removeResponsiveClass,
};
